"use client"

import React, { useEffect, useState } from 'react'
import styles from './styles.module.scss'
import ObservationCard from '../../observation-card/observation-card'
import SizeProduct from '../../products/size-product/size-product'
import { useCurrentProduct } from '@/src/context/product/current-product-context'
import Group from '../../products/wizard/question/group'
import { useMerchant } from '@/src/context/merchant/merchant-context'

type ProductType = 'size' | 'wizard' | 'simple' | 'combo'

export default function ProductDetails() {
    const { productDetails, canAddItem } = useCurrentProduct()
    const [productType, setProductType] = useState<ProductType | undefined>(undefined)
    const { merchantDetailed, localMode } = useMerchant()

    const renderDetails = () => {
        switch (productType) {
            case 'wizard':
                return <Group />
            case 'size':
                return <SizeProduct sizes={productDetails!.sizes} />
            default:
                return <div className={styles.emptySection}></div>
        }
    }

    useEffect(() => {
        if (productDetails) {
            if ((productDetails.sizes?.length ?? 0) > 0)
                setProductType('size')
            else if ((productDetails.itemGroups.length ?? 0) > 0)
                setProductType('wizard')
            else
                setProductType('simple')
        }
    }, [productDetails])

    return (
        <div className={styles.container}>
            {renderDetails()}
            {
                (canAddItem && !localMode && merchantDetailed?.model?.orderingMethod !== 'Disabled')
                && <ObservationCard />
            }
            {
                (canAddItem &&
                    merchantDetailed?.model?.paymentConfiguration.chargeForTheHighestAmount) &&
                <i className={`${styles.info} font-sm`}>*Será cobrado pelo sabor de maior valor.</i>
            }
        </div>
    )
}

